const React = require('react');
const T = require('prop-types');
const { NavLink: Link } = require('react-router-dom');
const { default: Styled } = require('styled-components');
const Footer = require('components/Footer');

const PlainLayout = require('./PlainLayout');
const AppBarLayout = require('./AppBarLayout');
const { default: IconButton } = require('@mui/material/IconButton');
const { default: CloseIcon } = require('@mui/icons-material/Close');
const { default: Tooltip } = require('@mui/material/Tooltip');
const { context } = require('app-context');
const { useAppSelector } = require('utils/redux');

const { useRef } = React;

const { selectors: { all: selectors } } = context;

const internals = {};

module.exports = function LegalPageLayout(props) {

    const { children } = props;

    const {
        TopRowExtras,
        StyledIconButton,
        InnerWrapper,
        FooterFixedContainer
    } = internals;

    // TODO footerRef.current doesn't exist for some reason,
    // was hoping to measure its clientHeight to set the bottom padding
    const footerRef = useRef(null);

    return (
        <PlainLayout>
            <AppBarLayout hideFooter>
                <InnerWrapper>
                    <TopRowExtras>
                        <Tooltip
                            arrow
                            title='Close'
                            placement='left'
                        >
                            <StyledIconButton
                                component={Link}
                                to='/'
                                aria-label='Close'
                                size='large'
                                data-focus-outline='radius:30,padding:-2,zIndex:1'
                            >
                                <CloseIcon />
                            </StyledIconButton>
                        </Tooltip>
                    </TopRowExtras>
                    {children}
                </InnerWrapper>
            </AppBarLayout>
            <FooterFixedContainer ref={footerRef}>
                <Footer />
            </FooterFixedContainer>
        </PlainLayout>
    );
};

module.exports.propTypes = {
    children: T.element.isRequired
};

internals.TopRowExtras = Styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;
    margin-left: -15px;
`;

internals.StyledIconButton = Styled(IconButton)`
    && {
        border: 2px solid rgba(0, 0, 0, 0.2);

        &:hover {
            border: 2px solid rgba(0, 0, 0, 0.4);
            background-color: rgba(0, 0, 0, 0.04);
        }
    }
`;

internals.InnerWrapper = Styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    margin-bottom: 100px;
`;

internals.FooterFixedContainer = Styled.div`
    position: fixed;
    left: 0;
    right: 0;
`;
